module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"link":"+ New application"},"et":{"link":"+ New application"},"ru":{"link":"+ New application"}}')
  delete Component.options._Ctor
}
